module.exports = __webpack_public_path__ + "static/media/pets-hotel-symbol-with-a-dog-and-a-cat-in-a-circle-with-one-star.846ac49b.png";